import { render, staticRenderFns } from "./circle-diagram.vue?vue&type=template&id=b4957656&"
import script from "./circle-diagram.js?vue&type=script&lang=js&"
export * from "./circle-diagram.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports